export default __webpack_public_path__ + "static/radial-gauge-in-react-1d1f647426bd1315ff8df57e21477f45.svg";